<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.401 3.003C10.556 1.003 13.444 1.003 14.599 3.003L21.954 15.751C23.108 17.751 21.665 20.251 19.356 20.251H4.644C2.335 20.251 0.892 17.751 2.046 15.751L9.401 3.003ZM12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V12.75C12.75 13.1642 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.1642 11.25 12.75V9C11.25 8.58579 11.5858 8.25 12 8.25ZM12 16.5C12.4142 16.5 12.75 16.1642 12.75 15.75C12.75 15.3358 12.4142 15 12 15C11.5858 15 11.25 15.3358 11.25 15.75C11.25 16.1642 11.5858 16.5 12 16.5Z"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconExclamationTriangle",
  props: ["height", "width"],
}
</script>
